import { request } from '@/utils';
import { ProposalVoter } from '@/views/Proposal/types';
import { useInfiniteQuery } from 'react-query';

const LIST_LIMIT = 20;

export const useProposalVoters = (id: string) => {
  const url = '/proposal/voters';
  return useInfiniteQuery(
    [url, id],
    ({ pageParam = 0 }) =>
      request.get<{
        voters: ProposalVoter[];
        total_count: number;
      }>(url, {
        id,
        start: pageParam,
        limit: LIST_LIMIT,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.voters?.length < LIST_LIMIT) {
          return false;
        }
        return allPages.length * LIST_LIMIT;
      },
    },
  );
};
